<template>
  <iframe
    :id="`formester-${id}`"
    ref="formesterIframe"
    :src="surveyUrl"
    frameborder="0"
    :height="calculatedHeight"
    :width="width"
    :sandbox="sandboxPermissions"
    :allow="allowedPermissions"
    style="transition: height 0.2s ease-out"
  />
</template>

<script>
import embedMixins from "@/components/mixins/embedMixins";

export default {
  mixins: [embedMixins],
  props: {
    id: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    // web components would not work with boolean values, not feasible to pass boolean through a html file
    setAutoHeight: {
      type: String,
      default: "false",
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      calculatedHeight: this.height,
    };
  },
  mounted() {
    if (this.setAutoHeight === "true") {
      window.addEventListener("message", (event) => {
        if (event.data.id && event.data.id === this.id && event.data.height) {
          this.calculatedHeight = event.data.height;
        }
      });
    }

    // Track iframe visibility on parent page
    this.initializeIframeVisibilityTracking();
  },
};
</script>

<style scoped></style>
